<template>
    <app-layout>
         <template v-slot:headerTitle>
        Create Report
    </template> 
     <template v-slot:tallystatus>
          <div  v-show="tally_open_status=='false'">
                <i class="fa fa-times refresh" aria-hidden="true" ></i>
          </div>
           <div  v-show="tally_open_status=='true'">
                <i class="fas fa-check refresh" aria-hidden="true" ></i>
          </div>
     </template>
    <template v-slot:headerNav>
                <jet-nav-link
                    :href="route('integrates.index')"
                    :active="route().current('integrates.index')"
                >
                    Excel
                </jet-nav-link>
                <jet-nav-link
                    class="ml-12"
                    :href="route('templates.index')"
                    :active="route().current('templates.index')"
                >
                    Template
                </jet-nav-link>
                <jet-nav-link
                    class="ml-12"
                    :href="route('configurations.index')"
                    :active="route().current('configurations.index')"
                >
                    Settings
                </jet-nav-link>
        </template>
       <div class="voucher-main-container grid grid-cols-4 gap-4">
         <div class="col-span-3">
              <div class="yellow-section pt-1" style="background-color: #e0f1fc">
              <h6 class=" pl-2 pr-2 px-3">
                <span class="voucher-heading pl-2">REPORT</span>
                 <span 
                    class="pr-2"
                    ><button
                      id="attribute_button"
                      class="inventory-submit-btn ml-2"
                      style="float: right"
                      @click="addAttribute($event)"
                      type="submit"
                    >
                      A
                    </button></span
                  >
                <span
                  ><button
                    id="report_button"
                    class="inventory-submit-btn ml-2"
                    style="float: right"
                    @click="addForm($event)"
                    type="submit"
                  >
                      F
                  </button></span
                >
              </h6>
            </div>
            <hr class="voucher-hr">
            <br>
              <div class="grid grid-cols-3 gap-2 px-4  -mb-5">
                    <label for="" class="col-span-1 text-left ">Name:</label>
                    <input class="form-input px-4 rounded-half w-half col-span-1 h-6" type="text" v-model="report.name" @input="saveDataView()">
              </div>
            <br>
            <div style="padding-bottom:1%;">
                          <!-- looping on report attributes -->
                          <div v-for="(value,index_at) in report.ATTRIBUTE" track-by="$Index" class="px-3   grid grid-cols-3 gap-4 "  > 
                              <div class="col-span-1 key">
                                <input class="px-2 rounded-half w-full h-6 mb-1" style="border:1px solid black;" v-model="value.name" list="attributes" name="select_attribute"  id="select_attribute" @input="setValueInputType(value,$event)" autocomplete="off" />
                                <datalist id="attributes">
                                  <option  v-for="(val_a_j,index) in this.attribute_json" :value="val_a_j.name" >{{val_a_j.name}}</option>
                                </datalist>
                              </div>
                              <div class="col-span-1 value_box text_box" >
                                    <input class="form-input px-2 rounded-half w-full h-6 mb-1" type="text" v-model="value.value" @input="saveDataView()">
                              </div>
                              <div class="col-span-1 value_box dropdown" style="display:none;">
                                    <input class="px-2 rounded-half w-full h-6 mb-1" style="border:1px solid black;" v-model="value.value" list="sec_attribute" name="select_attribute"  id="select_attribute"  autocomplete="off" @input="saveDataView()"/>
                                    <datalist  id="sec_attribute" class="dropdown" >
                                        <!-- <option v-for="(val_a_d,index) in bar('val_a_j')" >{{val_a_d.name}}</option> -->
                                    </datalist>
                              </div>
                              <div class="col-span-1 pt-0.5">
                                  <span
                                    ><button
                                      id="attribute_button"
                                      class="inventory-submit-btn ml-2 h-5"
                                      style="float: left;vertical-align:center;"
                                      @click="removeAttribute(value,index_at)"
                                      type="submit"
                                    >
                                      -
                                    </button></span
                                  >
                              </div>
                          </div>
                           <!-- looping on report attributes ends-->
                          <div v-for="(value,key) in report" track-by="$index">
                              <!-- form starts -->
                              <div class='key_data voucher-label ml-3' v-if="key=='FORM'" >
                                <reportform :form_arr="value" @addField="addField($event,field_type)" @addPart="addPart($event)" @addLine="addLine($event)" @saveDataView="saveDataView()" />
                              </div>
                              <!-- form ends -->   
                          </div>
                          <button class="h-4 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white w-20  px-2 border border-blue-500 hover:border-transparent  pb-6 mt-8 ml-3" @click="saveDataJson()" style="cursor:pointer;">submit</button>
            </div>
         </div>
          <div class="col-span-1">
              <p><iframe id="iframe"  :src="'/'+'report'+'.txt'" frameborder="0" height="400"
                width="95%"></iframe></p>
          </div>
        </div>
    </app-layout>
</template>
<script>
import reportform from './form';
import {saveToTxt,saveJson} from '../js/tdlbuilder.js';
import attribute_json from '../json/report_attribute.json';
import JetNavLink from '@/Jetstream/NavLink.vue';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
export default {
    name:"report",
    components:{
      reportform,
      AppLayout,
      JetResponsiveNavLink,
      JetNavLink
    },
    computed:{
        valueString(){
            let mod = JSON.stringify(this.report, null, 2);
            return mod;
        },
    },
    data:function(){
      return{
         report:{
           "type":"REPORT",
           "name":"",
           ATTRIBUTE:[]
         },
         PART:[],
         LINE:[],
         FIELD:[],
         ATTRIBUTE:[],
         sec_dropdown:[],
         attribute_json:attribute_json,
         file_name:"report"
      }
    },
    methods:{
          sd(val){
              console.log(val);
          },
          addForm(obj){
             if (obj.target.attributes.id.value == 'report_button') {
                var txtVal = 'FORM';
                if (!(txtVal in this.report)) {
                    this.FORM = [{
                      "type":"FORM",
                      "name":"",
                      ATTRIBUTE:[],
                    }];
                    this.report.FORM = this.FORM;
                }
                else if ((txtVal in this.report)) {
                    this.report.FORM.push({
                        "type":"FORM",
                        "name":"",
                        ATTRIBUTE:[],
                    });
                }
              }
              this.saveData()
          },
          addPart(obj){
                 var txtVal = 'PART';
                  if (!(txtVal in obj)) {
                      this.PART = [{
                          "type":"PART",
                          "name":"",
                          ATTRIBUTE:[]
                      }];
                      obj.PART = this.PART;
                  }
                  else if ((txtVal in obj)) {
                      this.PART = {
                          "type":"PART",
                          "name":"",
                           ATTRIBUTE:[]
                      }
                      obj.PART.push(this.PART);
                  }
                  this.saveData()
          },
          addAttribute(obj){
              if (obj.target.attributes.id.value == 'attribute_button') {
                var txtVal = 'ATTRIBUTE';
                if (!(txtVal in this.report)) {
                    this.ATTRIBUTE = [{
                       "name":"",
                       "value":""
                    }];
                    this.report.ATTRIBUTE = this.ATTRIBUTE;
                }
                else if ((txtVal in this.report)) {
                    this.report.ATTRIBUTE.push({
                        "name":"",
                        "value":""
                    });
                }
                this.saveData()
              }
          },
          removeForm(obj){
             if (obj.target.attributes.id.value == 'report_button') {
                var txtVal = 'FORM';
                if (!(txtVal in this.report)) {
                    this.FORM = [{
                       "name":"",
                    }];
                    this.report.FORM = this.FORM;
                }
                else if ((txtVal in this.report)) {
                    this.report.FORM.push({
                        "name":"",
                    });
                }
              }
          },
          removeAttribute(value,index){
                this.report.ATTRIBUTE.splice(index,1)
                this.saveData()
          },
          saveData(){
              var file_name = this.report.name;
              this.file_name = file_name;
              //convert javascript object into tdl string format
              var report_txt = "";
              var report_data = "";
              [this.report].forEach(function(value,key){
                  report_data = "";
                  if(value.type=="REPORT"){
                    var report_form_name ="FORM:";
                    var report_form_details ="";
                    var form_data = "";
                    var form_part_name = "";
                    var part_form_details ="";
                    var part_data = "";
                    var part_line_name = "";
                    var line_part_details ="";
                    var line_data = "";
                    var line_field_name = "";
                    var field_line_details ="";
                    var field_data = "";
                    report_txt = "["+value.type+":"+value.name+"]\n\t";
                    //fetching values from from objects and its attributes
                    if ("FORM" in value){
                    value.FORM.forEach(function(val_f,key_f){
                        if(report_form_name.length == 5){
                             report_form_name +=val_f.name;
                        }
                        else{
                             report_form_name +=","+val_f.name;
                        }
                        form_data = "\n\n["+val_f.type+":"+val_f.name+"]\n\t";
                        //fetch value from parts of the respected form
                        if ("PART" in val_f){
                            form_part_name = "PART:";
                            part_form_details ="";
                            part_data = "";
                            val_f.PART.forEach(function(val_p,key_p){
                                if(form_part_name.length == 5){
                                    form_part_name +=val_p.name;
                                }
                                else{
                                    form_part_name +=","+val_p.name;
                                }
                                part_data +=  "\n\n["+val_p.type+":"+val_p.name+"]\n\t";
                                //fetch value from lines of the respected part
                                if("LINE" in val_p){
                                    var bottomline_name = "BOTTOMLINE:";
                                    var topline_name = "TOPLINE:";
                                    line_part_details ="";
                                    line_data = "";
                                    val_p.LINE.forEach(function(val_l,key_l){
                                        if(val_l.heading == 'BOTTOMLINE'){
                                              val_p.LINE.forEach(function(val_l_c,key_l_c){
                                                  if(val_l_c.heading == "BOTTOMLINE"){
                                                    if(bottomline_name.indexOf(val_l_c.name) == -1){
                                                      if(bottomline_name.length == 11){
                                                         bottomline_name +=val_l_c.name;
                                                      }
                                                      else{
                                                         bottomline_name +=","+val_l_c.name;
                                                      }
                                                    }
                                                  }
                                              })
                                        }else{
                                            val_p.LINE.forEach(function(val_l_c,key_l_c){
                                                  if(val_l_c.heading  == "TOPLINE"){
                                                    if(topline_name.indexOf(val_l_c.name) == -1){
                                                      if(topline_name.length == 8){
                                                         topline_name +=val_l_c.name;
                                                      }
                                                      else{
                                                         topline_name +=","+val_l_c.name;
                                                      }
                                                    }
                                                  }
                                            })
                                        }
                                        line_data +=  "\n\n["+val_l.type+":"+val_l.name+"]\n\t";
                                        //fetch value from fields of the respected line
                                        if("FIELD" in val_l){
                                            var rightfield_name = "RIGHTFIELD:";
                                            var leftfield_name = "LEFTFIELD:";
                                            field_line_details ="";
                                            field_data = "";
                                            val_l.FIELD.forEach(function(val_f,key_f){
                                                 if(val_f.heading == 'RightField'){
                                                      val_l.FIELD.forEach(function(val_l_c,key_l_c){
                                                          if(val_l_c.heading == "RightField"){
                                                            if(rightfield_name.indexOf(val_l_c.name) == -1){
                                                                if(rightfield_name.length == 11){
                                                                  rightfield_name +=val_l_c.name;
                                                                }
                                                                else{
                                                                  rightfield_name +=","+val_l_c.name;
                                                                }
                                                            }
                                                          }
                                                      })
                                                  }else{
                                                      val_l.FIELD.forEach(function(val_l_c,key_l_c){
                                                            if(val_l_c.heading  == "LeftField"){
                                                              if(leftfield_name.indexOf(val_l_c.name) == -1){
                                                                if(leftfield_name.length == 10){
                                                                  leftfield_name +=val_l_c.name;
                                                                }
                                                                else{
                                                                  leftfield_name +=","+val_l_c.name;
                                                                }
                                                              }
                                                            }
                                                      })
                                                  }
                                                  field_data +=  "\n\n["+val_f.type+":"+val_f.name+"]\n\t";
                                                  if ("ATTRIBUTE" in val_l){
                                                      val_f.ATTRIBUTE.forEach(function(val_f_a,key_f_a){
                                                          field_data +=  val_f_a.name+":"+val_f_a.value+"\n\t";
                                                      })
                                                  }
                                            })
                                            if(leftfield_name.length ==10){
                                                leftfield_name='';
                                            }
                                            else{
                                                 line_data += leftfield_name+"\n\t";
                                            }
                                            if(rightfield_name.length ==11){
                                                rightfield_name='';
                                            }
                                            else{ 
                                                line_data += rightfield_name+"\n\t";
                                            }
                                        }
                                        //fetch value from fields of the respected line ends
                                        if ("ATTRIBUTE" in val_l){
                                            val_l.ATTRIBUTE.forEach(function(val_l_a,key_p_a){
                                                line_data +=  val_l_a.name+":"+val_l_a.value+"\n\t";
                                            })
                                            //adding field data to its parent line
                                            line_data += field_data;
                                        }
                                    })
                                    if(topline_name.length ==8){
                                          topline_name='';
                                    }
                                    else{
                                          part_data += topline_name+"\n\t";
                                    }
                                    if(bottomline_name.length ==11){
                                          bottomline_name='';
                                    }
                                    else{
                                           part_data += bottomline_name+"\n\t";
                                    }
                                    //topline_name+"\n\t" + bottomline_name+"\n\t";
                                }
                                //fetch value from lines of the respected part ends
                                if ("ATTRIBUTE" in val_p){
                                    val_p.ATTRIBUTE.forEach(function(val_p_a,key_p_a){
                                         part_data +=  val_p_a.name+":"+val_p_a.value+"\n\t";
                                    })
                                    //adding line data to its parent part
                                    part_data += line_data;
                                }
                            })
                            form_data += form_part_name+"\n\t";
                        }
                        //fetch value from parts of the respected form ends
                        val_f.ATTRIBUTE.forEach(function(val_f_a,key_f_a){
                          form_data = form_data + val_f_a.name+":"+val_f_a.value+"\n\t";
                        })
                        report_form_details = report_form_details + form_data;
                        report_form_details += part_data;
                    });
                  }
                  if("ATTRIBUTE" in value){
                      value.ATTRIBUTE.forEach(function(val_r_a,val_f_a){
                          report_data += val_r_a.name+":"+val_r_a.value+"\n\t";
                      })
                      report_txt +=  report_form_name+"\n\t";
                      report_txt +=  report_data;
                      report_txt +=  report_form_details;
                  } 
                  var _this = this;
                    saveToTxt(report_txt,file_name,_this);
                    var iframe = document.getElementById('iframe');
                    iframe.contentWindow.location.reload();
                  }
              });
          },
          setValueInputType(value,e){
              //loop on json containing attributes
              attribute_json.forEach(function(val,key){
                 if(value.name == val.name){
                   //loop on input html elements
                   for(var i=0;i<e.target.parentElement.parentElement.children.length;i++){
                     //check if a div element contains the given type in the name object
                     if(e.target.parentElement.parentElement.children[i].getAttribute('class').indexOf("value_box") != -1){
                            e.target.parentElement.parentElement.children[i].style.display = "none";
                     }
                     if(e.target.parentElement.parentElement.children[i].getAttribute('class').indexOf(val.type) != -1 ){
                        //changing style of display from none to block 
                        e.target.parentElement.parentElement.children[i].style.display = "block";
                        if(val.type == "dropdown"){
                          //add options to the select tag 
                          // e.target.parentElement.parentElement.children[i].children[0].html = '';
                          val.option.forEach(function(value,key){
                            var option = document.createElement("option");
                            option.text = value;
                            option.value = value;
                            e.target.parentElement.parentElement.children[i].children[1].append(option);
                          })
                        }
                     }
                   }
                 }
              })
              this.saveData();
          },
          saveDataView(){
              this.saveData();
          },
          saveDataJson(){
              var file_name = this.report.name;
              var file_name = "report";
              var report = JSON.stringify(this.report, null, 2);
              saveJson(report,file_name);
          }
    },
    mounted(){
    }
  }
</script>
<style>
li {
    border: none!important;
}
.box {
  border: 2px solid rgb(136, 136, 243);
  width: 550px;
}
.container{
    max-width: 1340px;
}
h6 {
  /* margin-block-start: 0px; */
  /* border-radius: 0px 0px 10px 10px; */
  margin: 0px 0px 0px !important;
  padding: 0px 0px 7px !important;
}
.key_data {
  padding-left: 1%;
  padding-right: 1%;
}
.inventory_header {
  margin-block-start: 0px;
  background-color: rgb(111, 203, 219);
  padding: 10px;
  border-radius: 10px 10px 10px 10px;
}
.ledger_header {
  margin-block-start: 0px;
  background-color: rgb(111, 203, 219);
  padding: 10px;
  border-radius: 10px 10px 10px 10px;
}
#amt {
  visibility: hidden;
}
#inventory {
  /* border: 2px solid lightgrey !important;
            border-top: none !important; */
}
#ledgers {
  /* border: 2px solid lightgrey !important;
            border-top: none !important; */
}
.btn {
  padding: 0 2% 0 2%;
}
.upload_box {
  width: 400px;
  box-sizing: border-box;
}
.upbtn {
  margin-top: 7px;
}
/* rejected css */
/* rejected css end */
.voucher-heading {
  font-size: 12px;
}
.inventory-submit-btn {
  font-size: 12px;
  border: 1px solid #2A66B1;
  color: #FFFFFF;
  /* padding-top: 3px; */
  padding-left: 10px;
  padding-right: 10px;
  background-color: #2A66B1;
}
.testimonial-group {
  padding: 0px !important;
}
.voucher-main-container {
  border: 1px solid #CECECE;
}
.voucher-hr {
  margin: 0px !important;
}
.file_upload[type="file"] {
  color: #2A66B1;
  font-size: 12px;
  border: 1px solid #2A66B1;
}
.voucher-select {
  border: 1px solid #CECECE;
}
.voucher-label {
  font-size: 12px;
  font-weight: bold;
}
.cmpName{
  font-size: 14px;
  font-weight: bold;
}
.file_upload[type="file"]::file-selector-button {
  border: 0px solid #2A66B1;
  padding: 0.4em 0.1em;
  color: #FFFFFF;
  border-radius: 0px !important;
  background-color: #2A66B1;
}
.voucher-select::after {
  color: #CECECE;
}
.display-block {
  display: inline;
}
.yellow-section {
}
.create-trp-lead-from {
  margin-top: -22px !important;
}
.refreshbutton {
  font-size: 12px;
  width: 20px !important;
  height: 20px !important;
  border: 0px solid #2A66B1;
  background-color: #2A66B1;
  border-radius: 100px;
  color: #FFFFFF;
  font-weight: 500;
}
.voucher_refreshbutton {
}
/* by rahul  end*/
.name{
    margin-left: 8rem;
  margin-right:5rem ;
}
@media (max-width: 640px) {
 .font{
     font-size: 11px;
 }
 .merg{
    margin-left: 15px;
    margin-right: 15px;
}
.inventory-submit-btn {
    font-size: 10px;
    border: 1px solid #2A66B1;
    color: #FFFFFF;
    padding-top: 3px;
    padding-bottom: 3px;
    padding-left: 7px;
    padding-right: 7px;
    background-color: #2A66B1;
    margin-left: 1px;
    margin-right: 1px;
  }
}
.sub{
   margin-top: 30px;
   margin-left: -203px;
}
.master{
    margin-top: 30px;
   margin-left: -210px;
}
.main-content {
  background-color: #F3F4F6;
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  margin-left: 212px;
  padding-bottom: 10px;
}
.container{
          text-align: center;
}
        /* upload image devex */
#dropzone-external {
  width: 320px;
  height: 70px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 2px;
  border-style: dashed;
  padding: 10px;
}
#dropzone-external > * {
  pointer-events: none;
}
#dropzone-external.dropzone-active {
  border-style: solid;
}
.widget-container > span {
  font-size: 14px;
  /* font-weight: bold; */
  margin-bottom: 5px;
  margin-top: 7px;
  margin-right: 240px;
}
#dropzone-image {
  max-width: 70%;
  max-height: 70%;
}
#dropzone-text > span {
  font-weight: 100;
  opacity: 0.5;
}
#upload-progress {
  display: flex;
  margin-top: 10px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px){
  #dropzone-external {
  width: 180px;
}
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  #dropzone-external {
  width: 180px;
}
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
     #dropzone-external {
  width: 200px;
}
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
     #dropzone-external {
  width: 230px;
}
}
@media only screen and (min-width: 1024px) {
     #dropzone-external {
  width: 260px;
}
}
@media only screen and (min-width: 1284px) {
     #dropzone-external {
  width: 280px;
}
}
@media only screen and (min-width: 1536px) {
     #dropzone-external {
  width: 320px;
}
}
.options {
  padding: 20px;
}
.inventory-btn {
  font-size: 12px;
  border: 1px solid #2A66B1;
  color: #FFFFFF;
  margin-top: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #2A66B1;
}
.dx-toast-content {
  min-width: 300px;
  max-width: 400px;
}
.curve {
  background: none;
  color: rgb(185, 184, 184);
  border: 1px solid rgb(185, 184, 184);
  border-radius: 5px;
  font-size: 16px;
  padding: 4px 12px;
  text-decoration: none; 
  }
   
</style>